export default "__VITE_ASSET__8fb2a057__"